import React, { useState, useEffect, useCallback } from "react";
import "./HomeCarousel.css";
import serverConfig from "../config";
import { useNavigate } from "react-router-dom";

const HomeCarousel = ({ slides, url_path, isSchool }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => {
      const nextIndex = prev + 1;
      return nextIndex >= slides.length ? 0 : nextIndex;
    });
  }, [slides.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  }, [slides.length]);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const handleSlideClick = (slide, currentSlide) => {
    const parts = slides[currentSlide].link.split("-");
    const year = parts[1];
    const name = parts[2];

    if (isSchool) {
      navigate(`/${slides[currentSlide].link}`);
    } else {
      navigate(`/${slides[currentSlide].link}`);
    }
  };

  return (
    <>
      {slides && slides.length > 0 && (
        <>
          {/*}
        <div className="carousel">
          <button className="carousel-button prev" onClick={prevSlide}>
            &lt;
          </button>
          <button className="carousel-button next" onClick={nextSlide}>
            &gt;
          </button>
          <div className="carousel-content">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`carousel-slide ${
                  index === currentSlide ? "active" : ""
                }`}
              >
                <div
                  className="conference-item-link"
                  onClick={() => handleSlideClick(slide, currentSlide)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={`${serverConfig.serverUrl}${url_path}${slide.img}`}
                    alt={`Slide ${index + 1}`}
                  />

                  <div className="carousel-text">
                    <h2>{slide.title}</h2>
                    <p>
                      {slide.start_date} / {slide.end_date}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="carousel-indicators">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`indicator ${
                  index === currentSlide ? "active" : ""
                }`}
                onClick={() => setCurrentSlide(index)}
              ></button>
            ))}
          </div>
        </div>
        */}

          {/*}
          <div className="carousel-content">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`carousel-slide ${
                  index === currentSlide ? "active" : ""
                }`}
              >
                <div className="carousel-row">
                  <div>
                    <button
                      className="carousel-button prev"
                      onClick={prevSlide}
                    >
                      &lt;
                    </button>
                  </div>

                    <div
                      className="conference-item-link"
                      onClick={() => handleSlideClick(slide, currentSlide)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={`${serverConfig.serverUrl}${url_path}${slide.img}`}
                        alt={`Slide ${index + 1}`}
                      />
                    </div>

                  <div>
                    <button
                      className="carousel-button next"
                      onClick={nextSlide}
                    >
                      &gt;
                    </button>
                  </div>
                </div>

                <div className="carousel-text">
                  <h2>{slide.title}</h2>
                  <p>
                    {slide.start_date} / {slide.end_date}
                  </p>
                </div>
              </div>
            ))}
          </div>
          */}

          {slides.map((slide, index) =>
            index === currentSlide ? (
              <div key={index}>
                <div className="row" style={{ height: "200px" }}>
                  <div
                    className="col-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      className="carousel-button prev"
                      onClick={prevSlide}
                    >
                      &lt;
                    </button>
                  </div>
                  <div
                    className="col-8"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      onClick={() => handleSlideClick(slide, currentSlide)}
                      style={{
                        cursor: "pointer",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={`${serverConfig.serverUrl}${url_path}${slide.img}`}
                        alt={`Slide ${index + 1}`}
                        style={{
                          maxWidth: "80%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="col-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      className="carousel-button next"
                      onClick={nextSlide}
                    >
                      &gt;
                    </button>
                  </div>
                </div>
                <div
                  className="row"
                  style={{
                    height: "120px",
                    backgroundColor: "#003366",
                    color: "white",
                  }}
                >
                  <div className="carousel-text">
                    <h2>{slide.title}</h2>
                    <p>
                      {slide.start_date} / {slide.end_date}
                    </p>
                  </div>
                </div>
                <div
                  className="row"
                  style={{
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center", // centra orizzontalmente
                    gap: "10px", // spazio tra i pallini
                  }}
                >
                  {slides.map((_, index) => (
                    <div
                      key={index}
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        border: index === currentSlide ? "" : "2px solid #003366",
                        cursor: "pointer",
                        background: index === currentSlide && "#003366",
                        transition: "background 0.3s",
                      }}
                      onClick={() => setCurrentSlide(index)}
                    ></div>
                  ))}
                </div>
              </div>
            ) : null
          )}
        </>
      )}
    </>
  );
};

export default HomeCarousel;
